import React from "react";
// Importación de imagen
import whyImg1 from "../../assets/img/Home/why-3.png";
import whyImg2 from "../../assets/img/Home/why-2.png";
import whyImg3 from "../../assets/img/Home/why-1.png";

const WhyChooseAlma = () => (
    <section className="section-why py-5">
        <div className="container">
            <div className="text-center mb-5">
                <h2>¿Por qué elegir a Alma?</h2>
            </div>
            <div className="row">
                <div className="col-lg-4 col-12 px-md-4 px-3">
                    <div className="card-why">
                        <div className="card-why__header">
                            <img src={whyImg1} alt="why" />
                        </div>
                        <div className="card-why__body">
                            <h3>Máxima seguridad</h3>
                            <p>Una plataforma 100% segura y mejoramiento continuo</p>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 col-12 px-md-4 px-3">
                    <div className="card-why">
                        <div className="card-why__header">
                            <img src={whyImg2} alt="why" />
                        </div>
                        <div className="card-why__body">
                            <h3>Envíos mega flash</h3>
                            <p>Logística propia para entregar pedidos en cuestión de horas</p>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 col-12 px-md-4 px-3">
                    <div className="card-why">
                        <div className="card-why__header">
                            <img src={whyImg3} alt="why" />
                        </div>
                        <div className="card-why__body">
                            <h3>Comunidad inspirada en ti</h3>
                            <p>Respetamos el planeta con piezas únicas producidas en pequeña escala</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
);

export { WhyChooseAlma };